module.exports = __webpack_public_path__ + "static/media/saint_chamas_pontflavien_tn.61aa1308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/saint_chamas_pontflavien_tn.jpg
// module id = 752
// module chunks = 0